const serviceFAQData = [
    {
      question: "What is included in your architectural design service?",
      answer: "Our architectural design service includes conceptual design, schematic design, design development, construction documentation, and assistance with permitting. We focus on creating functional and aesthetically pleasing designs tailored to your specific needs.",
    },
    {
      question: "Do you provide interior design services for all types of properties?",
      answer: "Yes, we offer interior design services for a wide range of properties, including residential homes, apartments, offices, retail spaces, and more. Our designs are customized to reflect your style and optimize your space.",
    },
    {
      question: "What types of construction services do you offer?",
      answer: "We provide comprehensive construction services, including new home construction, renovations, extensions, and custom builds. Our team handles everything from site preparation and foundation work to framing, electrical, plumbing, and finishing.",
    },
    {
      question: "Can you help with obtaining building permits?",
      answer: "Yes, we can assist with the process of obtaining building permits. We have experience navigating local regulations and can help ensure your project complies with all necessary requirements.",
    },
      {
      question: "What is included in the space planning and optimization service?",
      answer: "Our space planning and optimization service includes a thorough analysis of your existing space, development of layout options, furniture placement recommendations, and strategies to maximize functionality and flow.",
    },
    {
      question: "Do you offer 3D visualization for your designs?",
      answer: "Yes, we provide 3D visualization and rendering services to help you visualize your project before construction begins. This allows you to see the final look and feel of your space and make any necessary adjustments.",
    },
    {
      question: "How do you ensure quality in your construction projects?",
      answer: "We maintain high standards of quality by using premium materials, employing skilled craftsmen, and conducting regular inspections throughout the construction process. We also prioritize clear communication and collaboration with our clients.",
    },
    {
      question: "Can you manage the entire project from design to completion?",
      answer: "Yes, we offer comprehensive project management services, overseeing every stage of the project from initial design to final completion. This ensures seamless coordination and timely delivery of your project.",
    },
  ];

export default serviceFAQData;